const resolveClient = async (clientSource) =>
  typeof clientSource === "function" ? clientSource() : clientSource;

const firstRow = (data) => (Array.isArray(data) ? data[0] : data);

export const createCourseDeletionService = (clientSource) => ({
  async inspect(courseId) {
    const client = await resolveClient(clientSource);
    const { data, error } = await client.rpc("get_course_deletion_impact", {
      target_course_id: courseId,
    });
    if (error) throw error;
    const impact = firstRow(data);
    if (!impact) throw new Error("Course dependency check returned no result");
    return impact;
  },

  async remove(courseId, { force = false } = {}) {
    const client = await resolveClient(clientSource);
    const functionName = force
      ? "force_delete_course_with_cleanup"
      : "delete_course_safely";
    const { data, error } = await client.rpc(functionName, {
      target_course_id: courseId,
    });
    if (error) throw error;
    const result = firstRow(data);
    if (!result?.success) throw new Error("Course deletion returned no result");
    return result;
  },
});
